import { render, staticRenderFns } from "./ProductFamily.vue?vue&type=template&id=dc6d7276&scoped=true&"
import script from "./ProductFamily.vue?vue&type=script&lang=js&"
export * from "./ProductFamily.vue?vue&type=script&lang=js&"
import style0 from "./ProductFamily.vue?vue&type=style&index=0&id=dc6d7276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6d7276",
  null
  
)

export default component.exports